<table
  aria-label="table"
  mat-table
  [dataSource]="dataSourceInput"
  matSort
  (matSortChange)="onOrder($event)"
  class="mat-elevation-z8"
  *ngIf="dataSourceInput.length >= 1; else false"
>
  <ng-container matColumnDef="statusSemaphore">
    <th mat-header-cell *matHeaderCellDef>Status</th>
    <td mat-cell *matCellDef="let element">
      <span *ngIf="element.semaphoreColor == 'GREEN'" class="material-icons green-color">circle</span>
      <span *ngIf="element.semaphoreColor == 'YELLOW'" class="material-icons orange-color">circle</span>
      <span *ngIf="element.semaphoreColor == 'RED'" class="material-icons red-color">circle</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="firstTimeCrashReported">
    <th mat-header-cell mat-sort-header="firstTimeCrashReported" *matHeaderCellDef>First Time Crash Reported</th>
    <td mat-cell *matCellDef="let element">
      <span *ngIf="element.firstTimeCrashReported != 0">{{ element.firstTimeCrashReported | date: 'HH:mm:ss' }}</span>
      <span *ngIf="element.firstTimeCrashReported == 0">{{ element.firstTimeCrashReported }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="numTimes">
    <th mat-header-cell mat-sort-header="numTimes" *matHeaderCellDef>Num times</th>
    <td mat-cell *matCellDef="let element">{{ element.numTimes }}</td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell mat-sort-header="name" *matHeaderCellDef>Name</th>
    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
  </ng-container>

  <ng-container matColumnDef="maxAllowed">
    <th mat-header-cell mat-sort-header="maxAllowed" *matHeaderCellDef>Max allowed</th>
    <td mat-cell *matCellDef="let element">{{ element.maxAllowed }}</td>
  </ng-container>

  <ng-container matColumnDef="secondsPeriodAllowed">
    <th mat-header-cell mat-sort-header="secondsPeriodAllowed" *matHeaderCellDef>Seconds period allowed</th>
    <td mat-cell *matCellDef="let element">{{ element.secondsPeriodAllowed }}</td>
  </ng-container>

  <ng-container matColumnDef="ruleType">
    <th mat-header-cell mat-sort-header="ruleType" *matHeaderCellDef>Rule type</th>
    <td mat-cell *matCellDef="let element">{{ element.ruleType }}</td>
  </ng-container>

  <ng-container matColumnDef="jobName">
    <th mat-header-cell mat-sort-header="jobName" *matHeaderCellDef>Name</th>
    <td mat-cell *matCellDef="let element">{{ element.jobName }}</td>
  </ng-container>

  <ng-container matColumnDef="active">
    <th mat-header-cell *matHeaderCellDef>Active</th>
    <td mat-cell *matCellDef="let element">
      <mat-slide-toggle
        (change)="onChangeToggle(element.active, element.name || element.jobName)"
        [checked]="element.active"
      >
      </mat-slide-toggle>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
